export default __webpack_public_path__ + "static/media/flow-goal-gold.ecbaed04.svg";